import './style.scss';
import Label from 'components/Label';
import Button from 'components/common/Buttons';
import CheckBox from 'components/common/checkBox';
import { getTextContent } from 'helpers';
import { useAnimation, useAnimationBgParalax } from 'hooks/useAnimation';
import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectSubscribe } from 'store/slices/GeneralSlice';
import Mail from 'assets/icons/contacts/Letter.svg'
import { postNewsLetterSubscribe } from 'api/General';
import subscribeBg from 'assets/backgrounds/get-started.svg'
import subscribeBgMob from 'assets/backgrounds/getStartedBgMob.svg'
import useMediaQuery from 'hooks/useMediaQuery';
import useAnalyticsEventTracker from 'hooks/useAnalyticsEventTracker';



const NewsletterSubscriber = ({ isLoading }) => {
    const isTablet = useMediaQuery('max-width: 768px')

    const { tag,
        title,
        description,
        email_placeholder,
        button_text,
        policy_text,
        success_title,
        success_description
    } = useSelector(selectSubscribe);
    const [isSent, setSent] = useState(false);
    const [isEmailInputValid, setEmailValid] = useState(true);
    const [checkboxValid, setCheckboxValid] = useState(true);


    const [formData, setFormData] = useState({
        Email: '',
        termsCheck: false,
    });

    const handleInputChange = (field, value) => {
        setFormData((prevFormData) => ({ ...prevFormData, [field]: value }));
        setEmailValid(true)
    };
    const handleCheckboxChange = (isChecked) => {
        setFormData((prevFormData) => ({ ...prevFormData, termsCheck: isChecked }));
        setCheckboxValid(true)
    };
    const isEmailValid = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const eventTracker = useAnalyticsEventTracker({ category: "User", action: "Submit Subscribe in Blog" });

    const handleSubscribe = () => {
        if (!isEmailValid(formData.Email)) {
            setEmailValid(false)
            return;
        }
        if (!formData.termsCheck) {
            setCheckboxValid(false)
            return
        }

        eventTracker();

        const data = {
            data: {
                "email": formData.Email,
            }
        };

        postNewsLetterSubscribe({ data })
            .then(response => {
                setSent(true)
            })
            .catch(error => {
                console.error('Error:', error);
            });

        setSent(true);
    };


    const container = useRef();
    useAnimation({
        items: ['.newsletter-subscriber h2', '.newsletter-subscriber__desc', '.input-container'],
        container,
        dependencies: [isLoading],
    })

    useAnimationBgParalax({
        items: ['.newsletter-subscriber__bg'],
        container,
        dependencies: [isLoading],
    }
    )

    return (
        <section ref={container} className={`container newsletter-subscriber ${isSent ? "newsletter-subscriber-sent" : ""}`}>
            {isSent ?
                <>
                    <div className='newsletter-subscriber-label'>
                        <img src={Mail} alt="" />
                    </div>
                    <h2 className="h2">{success_title}</h2>
                    <div className="body2 newsletter-subscriber__desc">{success_description}</div>

                </>
                :
                <>
                    <Label text={tag} type="outline" />
                    <h2 className="h2">{title}</h2>
                    <div className="body2 newsletter-subscriber__desc">{description}</div>
                    <div className="input-container">
                        <div className='newsletter-subscriber__input'>
                            <input
                                className={`input ${isEmailInputValid ? '' : 'input--error'}`} type="email" name="Email" placeholder={email_placeholder} value={formData.Email} onChange={(e) => handleInputChange('Email', e.target.value)} />
                            {!isEmailInputValid && <div className='body3 error'>Incorrect value</div>}
                        </div>

                        <Button type="white" text={button_text} size="L" hasArrow={false} onClick={handleSubscribe} />
                    </div>
                    <div className="input-container">
                        <CheckBox id={'styledCheckbox'}
                            error={checkboxValid}
                            checked={formData.termsCheck}
                            onChange={handleCheckboxChange} />
                        <label htmlFor="styledCheckbox">
                            <div className="body4">{getTextContent(policy_text)}</div>
                        </label>
                    </div>
                </>
            }
            <img className='newsletter-subscriber__bg' src={isTablet ? subscribeBgMob : subscribeBg} alt="" />
        </section>
    );
};

export default NewsletterSubscriber;
